import { render, staticRenderFns } from "./index.vue?vue&type=template&id=047cd0cc"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('047cd0cc')) {
      api.createRecord('047cd0cc', component.options)
    } else {
      api.reload('047cd0cc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=047cd0cc", function () {
      api.rerender('047cd0cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/source/components/AppointDelivery/index.vue"
export default component.exports